module.exports = __webpack_public_path__ + "static/media/air-conditioner.65d9a1b0.svg";